import React, { FunctionComponent, useState } from 'react';

import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import 'common/response-editor/disclaimer-modal/DisclaimerModal.scss';

type DisclaimerModalProps = {
    isHealthcare?: boolean;
    onDecision: (publish: boolean) => void;
};

const shieldSvgPath =
    'M19.2598 5.25124L19.2127 5.24237C16.1906 4.66287 13.3934 3.04072 10.6609 0.282272L10.6488 0.270084C10.4822 0.101944 10.2567 0.00516532 10.0201 0.000200838C9.78342 -0.00476365 9.55412 0.0824751 9.38062 0.24348L9.33906 0.282268C6.60665 3.04072 3.80941 4.66287 0.787251 5.24238L0.740158 5.25125C0.531896 5.29127 0.344082 5.40259 0.209004 5.56608C0.0739256 5.72957 2.26663e-05 5.93501 8.27981e-09 6.14709V6.19418C-9.86649e-05 9.5445 0.881745 12.8358 2.55689 15.7373C4.23203 18.6388 6.64145 21.0482 9.54294 22.7233C9.67478 22.7992 9.8235 22.841 9.97558 22.8449C10.1277 22.8487 10.2783 22.8146 10.4139 22.7454L10.4571 22.7233C13.3586 21.0482 15.768 18.6388 17.4431 15.7373C19.1183 12.8358 20.0001 9.5445 20 6.19418V6.14709C20 5.93501 19.9261 5.72957 19.791 5.56608C19.6559 5.40259 19.4681 5.29126 19.2598 5.25124ZM10 20.7355V2.34432C12.5562 4.74376 15.2022 6.26565 18.0432 6.9698C17.9127 9.74302 17.1131 12.4435 15.7124 14.8406C14.3118 17.2377 12.3519 19.2602 10 20.7355Z';
const chipSvgPath =
    'M19.4137 10.5781C19.7319 10.5781 20 10.3182 20 9.99175C20 9.66527 19.7319 9.4054 19.4137 9.4054H17.4268V7.72203H19.4137C19.7319 7.72203 20 7.46216 20 7.13568C20 6.81744 19.7319 6.55018 19.4137 6.55018H17.4268V5.86926C17.4268 4.04857 15.9458 2.56657 14.1241 2.56657H13.4424V0.586349C13.4424 0.25987 13.1743 0 12.8561 0C12.5296 0 12.2697 0.259049 12.2697 0.586349V2.56657H10.5863V0.586349C10.5863 0.25987 10.3273 0 10 0C9.67352 0 9.41365 0.259049 9.41365 0.586349V2.56657H7.73029V0.586349C7.73029 0.25987 7.47124 0 7.14394 0C6.82569 0 6.55759 0.259049 6.55759 0.586349V2.56657H5.87831C4.05762 2.56657 2.57563 4.04847 2.57563 5.86926V6.55018H0.586349C0.268101 6.55018 0 6.81744 0 7.13568C0 7.46216 0.26808 7.72203 0.586349 7.72203H2.57563V9.4054H0.586349C0.268101 9.4054 0 9.66527 0 9.99175C0 10.3182 0.26808 10.5781 0.586349 10.5781H2.57563V12.2606L0.586349 12.2615C0.268101 12.2615 0 12.5213 0 12.8478C0 13.1661 0.26808 13.4342 0.586349 13.4342H2.57563V14.1151C2.57563 15.9366 4.0567 17.4184 5.87831 17.4184H6.55759V19.4052C6.55759 19.7235 6.82567 19.9916 7.14394 19.9916C7.47042 19.9916 7.73029 19.7235 7.73029 19.4052V17.4184H9.41365V19.4052C9.41365 19.7235 9.6727 19.9916 10 19.9916C10.3265 19.9916 10.5863 19.7235 10.5863 19.4052V17.4184H12.2697V19.4052C12.2697 19.7235 12.5288 19.9916 12.8561 19.9916C13.1743 19.9916 13.4424 19.7235 13.4424 19.4052V17.4184H14.1241C15.9457 17.4184 17.4268 15.9365 17.4268 14.1151V13.4342H19.4137C19.7319 13.4342 20 13.1661 20 12.8478C20 12.5213 19.7319 12.2615 19.4137 12.2615H17.4268V10.5789H19.4137V10.5781ZM15.3183 10.5584C15.3183 10.8199 15.1267 11.0419 14.8677 11.0789L13.8957 11.2204C13.7748 11.5131 13.7419 11.5912 13.621 11.8848L14.209 12.6718C14.3652 12.8807 14.3439 13.1735 14.1588 13.3585L13.3636 14.1537C13.1786 14.3387 12.8867 14.3593 12.677 14.2039L11.8916 13.6175C11.5972 13.7392 11.5191 13.7721 11.2255 13.8938L11.084 14.8634C11.0462 15.1216 10.825 15.314 10.5635 15.314H9.43848C9.17697 15.314 8.95493 15.1224 8.91792 14.8634L8.7773 13.8938C8.48372 13.7721 8.40478 13.74 8.11036 13.6175L7.325 14.2039C7.11613 14.3593 6.82337 14.3387 6.63834 14.1537L5.84231 13.3585C5.65728 13.1735 5.63672 12.8815 5.79297 12.6718L6.37847 11.8865C6.25677 11.5921 6.22387 11.5139 6.10298 11.2187L5.13342 11.0781C4.87519 11.0411 4.68277 10.819 4.68277 10.5575V9.43171C4.68277 9.17019 4.87438 8.94816 5.13342 8.91197L6.10298 8.77052C6.22469 8.47613 6.25759 8.398 6.37847 8.10441L5.79297 7.31823C5.63672 7.10935 5.6581 6.81659 5.84231 6.63238L6.63834 5.83635C6.82337 5.65132 7.1153 5.63077 7.325 5.78701L8.11036 6.37336C8.40476 6.25083 8.48288 6.21794 8.7773 6.09623L8.91792 5.12666C8.95575 4.86761 9.17697 4.67602 9.43848 4.67602H10.5635C10.825 4.67602 11.047 4.86763 11.084 5.12666L11.2255 6.09623C11.5199 6.21794 11.598 6.25083 11.8916 6.37336L12.677 5.78701C12.8867 5.63076 13.1786 5.65132 13.3636 5.83635L14.1588 6.63238C14.3439 6.81742 14.3652 7.11017 14.209 7.31905L13.6226 8.10441C13.7443 8.3988 13.7772 8.47693 13.899 8.77052L14.8685 8.91197C15.1276 8.94897 15.3192 9.17102 15.3192 9.43171V10.5575L15.3183 10.5584Z';

const IconSVG = (path: string) => (
    <svg
        className="title-icon"
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={path} />
    </svg>
);

export const DisclaimerModal: FunctionComponent<DisclaimerModalProps> = ({ isHealthcare, onDecision }) => {
    const { t } = useTranslation(['common/response-editor']);
    const title = t(`DISCLAIMER_MODAL_TITLE${isHealthcare ? '_HEALTHCARE' : ''}`);
    const message = t(`DISCLAIMER_MODAL_CONTENT${isHealthcare ? '_HEALTHCARE' : ''}`);
    const checkbox = t(`DISCLAIMER_MODAL_CHECKBOX${isHealthcare ? '_HEALTHCARE' : ''}`);
    const [isLoading, setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);
    };

    return (
        <Modal show centered>
            <Modal.Header>
                <Modal.Title>
                    <div className="disclaimer-modal-title">
                        {IconSVG(isHealthcare ? shieldSvgPath : chipSvgPath)}
                        {title}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="disclaimer-modal-content">
                <div className="disclaimer-modal-content__message">{message}</div>
                <Form.Check className="mr-2" type="checkbox">
                    <Form.Check.Input
                        type="checkbox"
                        className="disclaimer-checkbox"
                        style={{ accentColor: '#004F5D' }}
                        disabled={isLoading}
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Check.Label className="">{checkbox}</Form.Check.Label>
                </Form.Check>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="disclaimer-modal-cancel-button"
                    variant="outline-primary"
                    onClick={() => onDecision(false)}
                >
                    {t('CANCEL')}
                </Button>
                <Button
                    className="btn btn-primary disclaimer-modal-publish-button"
                    variant=""
                    disabled={!isChecked || isLoading}
                    onClick={() => {
                        setIsLoading(true);
                        onDecision(true);
                    }}
                >
                    {t('PUBLISH_ANYWAY')}
                    {isLoading && (
                        <div title={t('CONTENT_LOADING')}>
                            <i className="spinner icon-spinner" />
                        </div>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
